// Lightweight Twemoji helper — converts a Unicode emoji string to the SVG URL
// on the jsdelivr CDN, mirroring the codepoint logic of @twemoji/api.

const TWEMOJI_VERSION = '15.1.0'
const CDN_BASE = `https://cdn.jsdelivr.net/gh/jdecked/twemoji@${TWEMOJI_VERSION}/assets/svg`

const U200D  = String.fromCharCode(0x200d)
const UFE0F  = /️/g

function toCodePoint(str, sep = '-') {
  const out = []
  let p = 0
  let i = 0
  while (i < str.length) {
    const c = str.charCodeAt(i++)
    if (p) {
      out.push((0x10000 + ((p - 0xd800) << 10) + (c - 0xdc00)).toString(16))
      p = 0
    } else if (c >= 0xd800 && c <= 0xdbff) {
      p = c
    } else {
      out.push(c.toString(16))
    }
  }
  return out.join(sep)
}

export function emojiToCodePoint(emoji) {
  if (!emoji) return ''
  // Strip variation selector U+FE0F unless emoji uses ZWJ (joiners need it)
  return toCodePoint(emoji.indexOf(U200D) < 0 ? emoji.replace(UFE0F, '') : emoji)
}

export function emojiSvgUrl(emoji) {
  const cp = emojiToCodePoint(emoji)
  return cp ? `${CDN_BASE}/${cp}.svg` : null
}
